import script from "./DelConfrim.vue?vue&type=script&lang=ts&setup=true"
export * from "./DelConfrim.vue?vue&type=script&lang=ts&setup=true"

import "./DelConfrim.vue?vue&type=style&index=0&id=4ac7b367&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac7b367"]])

export default __exports__